import { ISOPROHeight, ISOPROLoadBearingCapacity } from '~/models/product/product.types';
import { FilterValues } from '~/store';

export const ShortElementMinHeights = new Map<
  ISOPROHeight,
  ISOPROLoadBearingCapacity[]
>();

ShortElementMinHeights.set(160, [10, 20, 30])
  .set(170, [40, 50, 60])
  .set(180, [70, 80, 90])
  .set(200, [100, 110, 120]);

export const ShearForceElementMinHeights = new Map<
  ISOPROHeight,
  ISOPROLoadBearingCapacity[]
>();

ShearForceElementMinHeights.set(160, [10, 20, 30, 40, 50, 60, 70, 80])
  .set(170, [90, 100])
  .set(180, [110, 120]);

export const VariantElementMinHeights = new Map<
  ISOPROHeight,
  ISOPROLoadBearingCapacity[]
>();
VariantElementMinHeights.set(160, [10])
  .set(170, [20, 30, 40])
  .set(180, [20, 30, 40]);

export function getElementThresholdLBC (
  filterValues: FilterValues,
  type: "shortElement" | "shearForceElement" | "variantElement"
): ISOPROLoadBearingCapacity | null {
  let thresholdLoadBearingCapacity: ISOPROLoadBearingCapacity | null =
    type === 'variantElement'
      ? 40
      : 120;
  if (type === 'variantElement'
    && (filterValues['variant'] === 'HV' || filterValues['variant'] === 'WO')
    || type !== 'variantElement') {
    const heights =
      type === "shearForceElement"
        ? ShearForceElementMinHeights
        : type === 'shortElement'
          ? ShortElementMinHeights
          : VariantElementMinHeights;
    if (filterValues["height"] !== "_none") {
      let isValidHeight = !!heights.get(+filterValues["height"] as ISOPROHeight);
      let validHeight = +filterValues["height"] as ISOPROHeight;
      while (!isValidHeight && validHeight > 0) {
        isValidHeight = !!heights.get(
          (validHeight - 10) as ISOPROHeight
        );
        validHeight = (validHeight - 10) as ISOPROHeight;
        // console.log('validHeight', validHeight);
      }
      if (validHeight > 0) {
        const setLength = heights.get(validHeight)?.length || 0;
        thresholdLoadBearingCapacity = heights.get(validHeight)?.[setLength - 1] || null;
      }
    }
  }
  return thresholdLoadBearingCapacity;
}

export function getElementThresholdHeight (
  filterValues: FilterValues,
  type: "shortElement" | "shearForceElement" | "variantElement"
): ISOPROHeight | null {
  let thresholdHeight: ISOPROHeight | null = null;
  if (type === 'variantElement') {
    const map = VariantElementMinHeights;
    map.forEach((lbcs, height) => {
      if (lbcs.includes(+filterValues['loadBearingCapacity'] as ISOPROLoadBearingCapacity))
        thresholdHeight = height;
    });
  } else {
    const map =
      type === "shearForceElement"
        ? ShearForceElementMinHeights
        : ShortElementMinHeights;

    map.forEach((lbcs, height) => {
      if (
        lbcs.includes(
          +filterValues["loadBearingCapacity"] as ISOPROLoadBearingCapacity
        )
      )
        thresholdHeight = height;
    });
  }
  return thresholdHeight;
}
